// 性别选择
export const genderList = [
    {id:0 , type:"男"},
    {id:1 , type:"女"},
];
// export const genderList = JSON.parse(JSON.stringify(genderList1))
// 角色选择
export const roleList = [
    {id:1 , type:"学生"},
    {id:2 , type:"教师"},
    {id:3 , type:"在职人员"},
    {id:4 , type:"待岗"},
    {id:5 , type:"退休"},
];

// 教育层次（学生、待岗、退休）
export const educationalLevelList = [
    {id:1 , type:"小学"},
    {id:2 , type:"普通初中"},
    {id:3 , type:"普通高中"},
    {id:4 , type:"中职"},
    {id:5 , type:"高职"},
    {id:6 , type:"继续教育"},
    {id:7 , type:"普通本科"},
    {id:8 , type:"硕士研究生"},
    {id:9 , type:"博士研究生"},
];
// 教学层次（老师）
export const teachingLevelList = [
    {id:1 , type:"小学"},
    {id:2 , type:"普通初中"},
    {id:3 , type:"普通高中"},
    {id:4 , type:"中职"},
    {id:5 , type:"高职"},
    {id:6 , type:"高校"},
];
// 研究方向
export const researchDirectionList = [
    {id:0 , type:"金融财经"},
    {id:1 , type:"工商管理"},
    {id:2 , type:"医学康养"},
    {id:3 , type:"文化旅游"},
    {id:4 , type:"红色思政"},
    {id:5 , type:"电子信息"},
    {id:6 , type:"智能制造"},
    {id:7 , type:"软件技术"},
    {id:8 , type:"人工智能"},
    {id:9 , type:"软件数据"},
    {id:10 , type:"智慧农业"},
    {id:11 , type:"教育培训"},
    {id:12 , type:"其它领域"},
];
// 工作领域（在职人员）
export const workAreaList = [
    {id:0 , type:"党政机关"},
    {id:1 , type:"专业技术"},
    {id:2 , type:"社会服务"},
    {id:3 , type:"农林牧渔"},
    {id:4 , type:"生产制造"},
    {id:5 , type:"其它领域"},
];
// 职称（教师）
export const academicTileList = [
    {id:0 , type:"教授"},
    {id:1 , type:"副教授"},
    {id:2 , type:"讲师"},
    {id:3 , type:"助教"},
    {id:4 , type:"研究员"},
    {id:5 , type:"副研究员"},
    {id:6 , type:"助理研究员"},
    {id:7 , type:"研究实习员"},
    {id:8 , type:"高级实验师"},
    {id:9 , type:"实验师"},
    {id:10 , type:"助理实验师"},
    {id:11 , type:"实验员"},
    {id:12 , type:"高级工程师"},
    {id:13 , type:"工程师"},
    {id:14 , type:"助理工程师"},
    {id:15 , type:"正高级教师"},
    {id:16 , type:"高级教师"},
    {id:17 , type:"一级教师"},
    {id:18 , type:"二级教师"},
    {id:19 , type:"三级教师"},
    {id:-1 , type:"其它"},
];
// 表单对象
export const regForm = {
    username:'',
    phone:'',
    gender:'',
    birthday:'',
    roleId:1,
    educationalLevel:'',
    teachingLevel:'',
    provinceId:'',
    cityId:'',
    schoolId:'',
    schooleName:'',
    collegeType:'',
    major:'',
    researchDirection:'',
    academicTile:'',
    workArea:'',
    workUnit:'',
    workDepartment:'',
    password:'',
    rePassword:'',
    phoneVerifyCode:'',
};
// 表单校验规则
export const regRules = {
    username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
    phone: [{ required: true, message: '请输入手机号', trigger: 'blur' }],
    gender: [{ required: true, message: '请选择性别', trigger: 'blur' }],
    birthday: [{ required: true, message: '请输入出生年月', trigger: 'blur' }],
    roleId: [{ required: true, message: '请选择身份', trigger: 'blur' }],
    educationalLevel: [{ required: true, message: '请选择教育层次', trigger: 'blur' }],
    teachingLevel: [{ required: true, message: '请选择教学层次', trigger: 'blur' }],
    provinceId: [{ required: true, message: '请选择学校所在省', trigger: 'blur' }],
    cityId: [{ required: true, message: '请选择学校所在市', trigger: 'blur' }],
    schoolId: [{ required: true, message: '请选择所在学校', trigger: 'blur' }],
    collegeType:[{ required: true, message: '请填写所在学院/系', trigger: 'blur' }],
    major:[{ required: true, message: '请选择所在专业', trigger: 'blur' }],
    researchDirection:[{ required: true, message: '请选择研究方向', trigger: 'blur' }],
    academicTile:[{ required: true, message: '请选择职称', trigger: 'blur' }],
    workArea:[{ required: true, message: '请选择工作领域', trigger: 'blur' }],
    workUnit:[{ required: true, message: '请选择工作单位', trigger: 'blur' }],
    workDepartment:[{ required: true, message: '请选择工作部门', trigger: 'blur' }],
    password: [
        { required: true, message: '请输入密码', trigger: 'blur' },
        { pattern: /^.{8,}$/, message: '请输入8-16位密码，区分大小写', trigger: 'blur' }
    ],
    rePassword: [
        { required: true, message: '请再次输入密码', trigger: 'blur' },
        { pattern: /^.{8,}$/, message: '请输入8-16位密码，区分大小写', trigger: 'blur' }
    ],
    phoneVerifyCode:[{ required: true, message: '请输入验证码', trigger: 'blur' }],
};